import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faIdCard,
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
  faArrowLeft,
  faExclamationCircle,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import "./Insured.css";
import { apiRequest } from "../../services";
import CakeIcon from '@mui/icons-material/Cake';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import CabinIcon from '@mui/icons-material/Cabin';

const InsuredPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const accountData = location.state?.accountInsured;
  const userData = useSelector((state) => state.users);
  const [insuredInfo, setInsuredInfo] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleBackToAccount = () => {
    navigate(`/mon-compte`, {
      state: { account: accountData },
    });
  };

  const fetchInsuredByInsuranceId = async () => {
    setLoading(true);
    try {
      const requestData = {
        serviceReference: "GET_INSURED_BY_INSURANCE_ID",
        requestBody: accountData.contractNumber,
      };
      const response = await apiRequest(
        "GATEWAY",
        "",
        "POST",
        requestData,
        userData.token,
        dispatch,
        navigate
      );
      if (
        response &&
        response.status === 200 &&
        response.body.meta.statusCode === 200
      ) {
        console.log("======>>>>>>>>", response.body.data);
        console.log("======+>>>>>>>>", response.body.data.assuredCniIssueDate);
        setInsuredInfo(response.body.data);
      } else {
        console.log("Response to fetch insured info: ", response);
      }
    } catch (error) {
      console.error("Error retrieving insured information: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInsuredByInsuranceId();
  }, []);

  // Compter les champs "N/A" ou vides
  const fields = [
    insuredInfo.assuredFirstName,
    insuredInfo.assuredSurName,
    insuredInfo.assuredDateOfBirth,
    insuredInfo.assuredPlaceOfBirth,
    insuredInfo.assuredProfession,
    insuredInfo.assuredAdresse,
    insuredInfo.assuredEmail,
    insuredInfo.assuredMsisdn,
    insuredInfo.contractNumber,
    insuredInfo.assuredCniNumber,
    insuredInfo.assuredCniIssueDate,
    insuredInfo.assuredCniPlaceOfIssue,
    insuredInfo.beneficiaryFirstName,
    insuredInfo.beneficiarySurName,
    insuredInfo.beneficiaryDateOfBirth,
    insuredInfo.beneficiaryMsisdn,
  ];
  console.log("+++++++++>>>>>>>>>",fields);

  const naCount = fields.reduce((count, field) => {
    return count + (field === "N/A" || !field ? 1 : 0);
  }, 0);

  // Afficher le spinner pendant le chargement
  if (loading) {
    return (
      <div className="beneficiary-container animate__animated animate__fadeIn">
        <div className="beneficiary">
          <div className="overlay-text">
            <h1>{accountData?.savingPlanDescription || t("InsuredInfo")}</h1>
          </div>
        </div>
        <div className="loading-spinner-container">
          <FontAwesomeIcon 
            icon={faSpinner} 
            spin 
            size="3x" 
            className="loading-spinner"
          />
          <p>{t("loading")}</p>
        </div>
      </div>
    );
  }

  // Si au moins 3 champs sont "N/A" ou vides, afficher un message
  if (naCount >= 3) {
    return (
      <div className="beneficiary-container animate__animated animate__fadeIn">
        <div className="beneficiary">
          <div className="overlay-text">
            <h1>{accountData?.savingPlanDescription || t("InsuredInfo")}</h1>
          </div>
        </div>
        <div className="no-insured-message animate__animated animate__fadeInUp">
          <FontAwesomeIcon icon={faExclamationCircle} className="no-insured-icon" />
          <h3>{t("notInsured")}</h3>
          <p>{t("notInsuredInfo")}</p>
          <button className="action-button" onClick={handleBackToAccount}>
            <FontAwesomeIcon icon={faArrowLeft} />
            {t("carouselPrev")}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="beneficiary-container animate__animated animate__fadeIn">
      <div className="beneficiary">
        <div className="overlay-text">
          <h1>{accountData?.savingPlanDescription || t("InsuredInfo")}</h1>
        </div>
      </div>

      <div className="account-details cards animate__animated animate__fadeInUp">
        <div className="account-header">
          <div>
            <h3 className="beneficiary-hospi-header">
              <FontAwesomeIcon icon={faUser} className="me-2" />
              {t("hospiInfo")}
            </h3>
          </div>
        </div>

        <div className="account-info-grid">
          <div className="section-title gradient-text">
            <h4>{t("personnelInfo")}</h4>
          </div>

          <div className="info-item-account">
            <label className="info-label">
              <FontAwesomeIcon icon={faUser} />
              {t("nom")}
            </label>
            {/* <p className="info-value">{insuredInfo.assuredFirstName || "N/A"}</p> */}
            <p className="info-value">
             {insuredInfo.assuredFirstName && insuredInfo.assuredSurName
              ? `${insuredInfo.assuredSurName} ${insuredInfo.assuredFirstName}`
              : "N/A"}
            </p>
          </div>

          <div className="info-item-account">
            <label className="info-label">
              <CakeIcon />
              {t("birthDay")}
            </label>
            <p className="info-value">{insuredInfo.assuredDateOfBirth || "N/A"}</p>
          </div>

          <div className="info-item-account">
            <label className="info-label">
              <FontAwesomeIcon icon={faMapMarkerAlt} />
              {t("Lieu de Naissance")}
            </label>
            <p className="info-value">{insuredInfo.assuredPlaceOfBirth || "N/A"}</p>
          </div>

          <div className="info-item-account">
            <label className="info-label">
              <BusinessCenterIcon />
              {t("Profession")}
            </label>
            <p className="info-value">{insuredInfo.assuredProfession || "N/A"}</p>
          </div>

          <div className="section-title gradient-text">
            <h4>{t("Coordonnées")}</h4>
          </div>

          <div className="info-item-account">
            <label className="info-label">
              <CabinIcon />
              {t("Adresse")}
            </label>
            <p className="info-value">{insuredInfo.assuredAdresse || "N/A"}</p>
          </div>

          <div className="info-item-account">
            <label className="info-label">
              <FontAwesomeIcon icon={faEnvelope} />
              {t("Email")}
            </label>
            <p className="info-value">{insuredInfo.assuredEmail || "N/A"}</p>
          </div>

          <div className="info-item-account">
            <label className="info-label">
              <FontAwesomeIcon icon={faPhone} />
              {t("phoneNumber")}
            </label>
            <p className="info-value">{insuredInfo.assuredMsisdn || "N/A"}</p>
          </div>

          <div className="info-item-account">
            <label className="info-label">
              <FontAwesomeIcon icon={faUser} />
              {t("Numero de contrat")}
            </label>
            <p className="info-value">{insuredInfo.contractNumber || "N/A"}</p>
          </div>

          <div className="section-title gradient-text">
            <h4>{t("identitySection")}</h4>
          </div>

          <div className="info-item-account">
            <label className="info-label">
              <FontAwesomeIcon icon={faIdCard} />
              {t("cni")}
            </label>
            <p className="info-value">{insuredInfo.assuredCniNumber || "N/A"}</p>
          </div>

          <div className="info-item-account">
            <label className="info-label">
              <FontAwesomeIcon icon={faMapMarkerAlt} />
              {t("idIssueDate")}
            </label>
            <p className="info-value">{insuredInfo.assuredCniIssueDate || "N/A"}</p>
          </div>

          <div className="info-item-account">
            <label className="info-label">
              <FontAwesomeIcon icon={faMapMarkerAlt} />
              {t("idPlaceOfIssue")}
            </label>
            <p className="info-value">{insuredInfo.assuredCniPlaceOfIssue || "N/A"}</p>
          </div>

          <div className="section-separator">
            <div>
              <h3 className="beneficiary-hospi-header">
                <FontAwesomeIcon icon={faUser} className="me-2" />
                {t("decesInformation")}
              </h3>
            </div>
          </div>

          <div className="info-item-account">
            <label className="info-label">
              <FontAwesomeIcon icon={faUser} />
              {t("nom")}
            </label>
            <p className="info-value">{insuredInfo.beneficiarySurName || "N/A"}</p>
          </div>

          <div className="info-item-account">
            <label className="info-label">
              <FontAwesomeIcon icon={faUser} />
              {t("SurName")}
            </label>
            <p className="info-value">{insuredInfo.beneficiaryFirstName || "N/A"}</p>
          </div>

          <div className="info-item-account">
            <label className="info-label">
              <CakeIcon />
              {t("birthDay")}
            </label>
            <p className="info-value">{insuredInfo.beneficiaryDateOfBirth || "N/A"}</p>
          </div>

          <div className="info-item-account">
            <label className="info-label">
              <FontAwesomeIcon icon={faPhone} />
              {t("phoneNumber")}
            </label>
            <p className="info-value">{insuredInfo.beneficiaryMsisdn || "N/A"}</p>
          </div>
        </div>

        <div className="account-actions animate__animated animate__fadeInUp">
          <button className="action-button" onClick={handleBackToAccount}>
            <FontAwesomeIcon icon={faArrowLeft} />
            {t("carouselPrev")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InsuredPage;